import { ofType } from 'redux-observable';
import { Observable, concatMap, filter, of } from 'rxjs';
import { AppEpic, AppThunk } from 'src/store';
import { setRightContainerPayload } from '../RightContainer/RightContainer.slice';
import { RightContainerPayloadType } from '../RightContainer/RightContainer';
import { getChats, getAgentConfig, createChat } from './Agent.actions';

export const handleFetchAgentData: AppEpic = (action$): Observable<AppThunk> => {
  return action$.pipe(
    ofType(setRightContainerPayload.type),
    filter((r) => {
      return r.payload.type === RightContainerPayloadType.Agent;
    }),
    concatMap(() => of(getChats(), getAgentConfig())),
  );
};

export const handleEmptyChats: AppEpic = (action$): Observable<AppThunk> => {
  return action$.pipe(
    ofType(getChats.fulfilled.type),
    filter((action) => {
      return Array.isArray(action.payload) && action.payload.length === 0;
    }),
    concatMap(() => of(createChat())),
  );
};
